// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1___39b33dfc51d28372dcc","cls2":"CreateSocialItemModal-cls2__f90e66606f38c3ba71bd CreateSocialItemModal-cls1___39b33dfc51d28372dcc"};